import React, { Component } from "react";
import { message, Icon, Input, Button, Col, Popconfirm, Form, Table, Divider, DatePicker } from "antd";
import "../App.css";
import { Link } from 'react-router-dom'
import moment from 'moment';

// We import our firestore module
import { db } from '../firebase/firebase';

const InputGroup = Input.Group;


//=================editable==========================
const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
//=================editable==========================

class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <DatePicker />;
    }
    return <Input />;
  };

  render() {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      ...restProps
    } = this.props;
    return (
      <EditableContext.Consumer>
        {(form) => {
          const { getFieldDecorator } = form;
          return (
            <td {...restProps}>
              {editing ? (
                <FormItem style={{ margin: 0 }}>
                  {getFieldDecorator(dataIndex, {
                    rules: [{
                      required: true,
                      message: `Please Input ${title}!`,
                    }],
                    initialValue: record[dataIndex],
                  })(this.getInput())}
                </FormItem>
              ) : restProps.children}
            </td>
          );
        }}
      </EditableContext.Consumer>
    );
  }
}

export class Values extends Component {
  constructor(props) {
    super(props);

    // Set the default state of our application
    this.state = {
      addingEvent: false,
      pendingTitle: "",
      pendingDate: moment(),
      sortdate: moment(),
      allowDelete: true,

      data: [],
      mama: [],
      jj: [],
      editingKey: '',
      da: null,
      ta: null,
    };
    this.columns = [
      {
        title: 'Key',
        dataIndex: 'keyy',
        ...this.getColumnSearchProps('keyy'),
        editable: true,
        sorter: (a, b) => { return a.keyy.localeCompare(b.keyy) },
      },
      {
        title: 'Value',
        dataIndex: 'value',
        ...this.getColumnSearchProps('value'),
        editable: true,
        sorter: (a, b) => { return a.value.localeCompare(b.value) },
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '15%',
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              {editable ? (
                <span>
                  <EditableContext.Consumer>
                    {form => (
                      <Button
                      onClick={() => this.save(form, record.key)}
                      style={{ marginRight: 8 }}
                    >
                      Save
                    </Button>
                    )}
                  </EditableContext.Consumer>
                  <Button
                    type="primary"
                    style={{ marginRight: 8 }}
                    onClick={() => this.cancel(record.key)}
                  >
                    Cancel
                  </Button>
                </span>
              ) : (
                  <div>
                    <Button
                      onClick={() => this.edit(record.key)}
                      className="App-t"
                    >
                      Edit
                </Button>
                    <Divider type="vertical" />

                    <Popconfirm
                      title="Confirm Delete?"
                      onConfirm={evt => this.deleteTheEvent(record.key)}
                    >
                      <Button
                        className="App-t"
                      >
                        Delete
                </Button>
                    </Popconfirm>

                  </div>
                )}
            </div>
          );
        },
      },
    ];

    // We want event handlers to share this context
    this.addEvent = this.addEvent.bind(this);
    this.deleteEntry = this.deleteEntry.bind(this);
    this.deleteTheEvent = this.deleteTheEvent.bind(this);
    this.updateEvent = this.updateEvent.bind(this);
    this.handleChange = this.handleChange.bind(this);
    //start the engine
    this.pullFromDB();
  }


  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => { this.searchInput = node; }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
        </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
        </Button>
        </div>
      ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      text
    ),
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }
  pullFromDB() {
    // We listen for live changes to our events collection in Firebase
    db.collection("values").onSnapshot(snapshot => {
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);
      });


      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }
      // console.log(data);


      // Anytime the state of our database changes, we update state
      this.setState({ data });

    })
  }


  async deleteTheEvent(pid) {
    // console.log("delete event" + this.state.data[pid].id + JSON.stringify(this.state.data))
    await db
      .collection("values")
      .doc(this.state.data[pid].id)
      .delete();

  }



  async deleteEntry(pid) {
    await db.collection("eventmedia").where("event", "==", this.state.data[pid].id).onSnapshot(snapshot => {
      let mama = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        mama.push(todo);
      });
      if (mama.length === 0) {
        this.deleteTheEvent(pid);
      } else {
        alert("Delete the associating media first.")
      }
    })
  }


  async updateEvent(id) {
    // console.log("update! record.key: " + id + "todo id: " + this.state.data[id].id)
    // console.log("firebasing the pa ta xa...: " + this.state.da + this.state.ta)
   
  }

  async addEvent() {
    //if no title, prohibit adding new event
    if (!this.state.pendingTitle) return;

    // Set a flag to indicate loading
    this.setState({ addingEvent: true });

    // Add a new event from the value of the input
    // console.log("adding event titled: ", this.state.pendingTitle)
    var bb = await db.collection("values").add({
      keyy: this.state.pendingTitle,
      value: this.state.pendingTitle,
    });

    // Remove the loading flag and clear the input
    this.setState({ addingEvent: false, pendingTitle: "", pendingDate: moment(), sortdate: moment() });
  }

  handleChange(date) {
    this.setState({
      pendingDate: date,
      sortdate: date
    });
  }


  exportTime(x) {
    // var a = x.format("DD-MM-YYYY");
    var a = x.format("DD-MM-YYYY");
    return a;
  }

  importTime(s) {
    var v = new Date(s);
    return v.toLocaleString();
  }













  isEditing = (record) => {
    return record.key === this.state.editingKey;
  };

  edit(key) {
    this.setState({ editingKey: key });
  }

  save(form, key) {
    form.validateFields((error, row) => {
      if (error) {
        return;
      }
      const newData = [...this.state.data];
      const index = newData.findIndex(item => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });


        // alert("OLD DATA: " + JSON.stringify(this.state.data[index]))
        // alert("the pa ta xa...: " + this.state.pa + this.state.ta + this.state.xa + this.state.ya + this.state.sa)

       
        db
        .collection("values")
        .doc(this.state.data[index].id).update({
           //to do in the future: maybe convert the user editted date into isostring format, so can store together
           keyy: newData[index].keyy,
           value: newData[index].value
        })
        .then(() => {
          message.destroy()
          message.success("Document successfully updated!");
          this.setState({ data: newData, editingKey: '' });
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          message.destroy()
          message.error("Error updating document: " + error.message);
        });
       
        
      } else {
        newData.push(row);
        this.setState({ data: newData, editingKey: '' });
      }
    });
  }

  cancel = () => {
    this.setState({ editingKey: '' });
  };











  render() {
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'age' ? 'number' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });


    return (
      <div>
        <h1>Values</h1>
            <Input
              ref="add-todo-input"
              className="inputt bp3-input .bp3-large"
              size="large"
              placeholder="Title"
              disabled={this.state.addingEvent}
              onInput={evt => this.setState({ pendingTitle: evt.target.value })}
              value={this.state.pendingTitle}
              required
            />
            <Button
              className="inputt App-add-todo-button"
              size="large"
              type="primary"
              onClick={this.addEvent}
              loading={this.state.addingEvent}
            >
              Add Values
          </Button>










        <Table
          components={components}
          bordered
          dataSource={this.state.data}
          columns={columns}
          rowClassName="editable-row"
        />





        {/* <List
            className="App-todos"
            size="large"
            bordered
            dataSource={this.state.todos} //all the content arrays, *render item* is specific content of array
            renderItem={todo => (
              <List.Item>
                {todo.date} {}
                {todo.content} {'  MYR '}
                {todo.amount}
                <Icon
                  onClick={evt => this.deleteEntry(todo.id)}
                  className="App-todo-complete"
                  type="cross"
                />
              </List.Item>
            )}
          /> */}
      </div>
    )
  }
}
export default Values;



// WEBPACK FOOTER //
// ./src/views/values.js